import { Outlet } from 'react-router-dom';
import { BackgroundImage, Box } from 'ui';

// TODO: (FTUX) Replace with OnboardingLayout from core @Dylan-Brandenburg
const OnboardingLayout = () => {
  return (
    <BackgroundImage src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/onboarding/onboarding-background.jpg">
      <Box
        style={{
          height: '100vh',
          width: '100vw',
          paddingTop: 'var(--safe-area-top)',
        }}
      >
        <Outlet />
      </Box>
    </BackgroundImage>
  );
};

export { OnboardingLayout };
